module.exports = __webpack_public_path__ + "img/arrow.7831f9e7.svg";